"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_OWNER = void 0;
exports.BUILD_OWNER = {
    AUTORESPONDER: 'AUTORESPONDER',
    LANDING: 'LANDING',
    TEMPLATE: 'TEMPLATE'
};
//# sourceMappingURL=buildOwner.js.map